import axios from './axios';

export const createSociety = async (onboardingData) => {
  return await axios.post('/api/v1/onboarding/create-society', onboardingData);
};

export const createAuthSociety = async (onboardingData) => {
  return await axios.post('/api/v1/user/societies', onboardingData);
};

export const sendVerificationOtp = async (contact, channel) => {
  const response = await axios.post('/api/v1/onboarding/send-verification-otp', {
    contact,
    channel,
  });
  return response?.data || response;
};

export const verifyOtp = async (contact, code) => {
  const response = await axios.post('/api/v1/onboarding/verify-otp', {
    contact,
    code,
  });
  return response?.data || response;
};
